import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'

import ShowContactLog from './-components/ShowContactLog'

const searchParamsSchema = z.object({
  t: z.number().optional(),
})

export const Route = createFileRoute(
  '/_authenticated/$alias/_app/interaction/$contactLogId/',
)({
  validateSearch: searchParamsSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  return <ShowContactLog contactLogId={params.contactLogId} />
}
